import { Toaster } from '@repo/shadcn';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@/app/app';
import { store } from '@/features/store-setup';

import { CommonProvider } from './providers';
import './styles.css';

const root = createRoot(document.getElementById('root') as Element);

root.render(
    <StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                <CommonProvider>
                    <App />
                </CommonProvider>
            </Provider>
            <Toaster
                closeButton={true}
                expand={true}
                richColors={true}
                theme="light"
                toastOptions={{
                    classNames: {
                        success: 'bg-green-600 text-white',
                        error: 'bg-red-600 text-white',
                        info: 'bg-blue-600 text-white',
                        warning: 'bg-yellow-600 text-black',
                    },
                }}
            />
        </BrowserRouter>
    </StrictMode>,
);
